// Shared checkbox list with mutual-exclusion support.
// * value item can force-mutex others (e.g. 'none', 'no_preference').

import React from 'react';

export function CheckboxList({
  options,
  value = [],
  mutexId,
  onChange,
  name,
  ariaLabel,
  testIdPrefix = 'cb',
}) {
  const toggle = (id) => {
    let next;
    if (id === mutexId) {
      // clicking mutex clears others
      next = value.includes(mutexId) ? [] : [mutexId];
    } else {
      const without = value.filter((v) => v !== mutexId && v !== id);
      next = value.includes(id) ? without : [...without, id];
    }
    onChange(next);
  };

  return (
    <div role="group" aria-label={ariaLabel} className="grid gap-2 sm:grid-cols-2">
      {options.map((o) => {
        const selected = value.includes(o.id);
        return (
          <label
            key={o.id}
            className="flex items-start gap-3 p-3 cursor-pointer transition-colors"
            style={{
              background: selected ? 'rgba(239,104,32,0.08)' : '#fff',
              border: selected ? '2px solid var(--orange)' : '1.5px solid var(--line)',
              borderRadius: 'var(--radius)',
            }}
            data-testid={`${testIdPrefix}-${o.id}-label`}
          >
            <input
              type="checkbox"
              name={name}
              checked={selected}
              onChange={() => toggle(o.id)}
              aria-checked={selected}
              data-testid={`${testIdPrefix}-${o.id}-input`}
              style={{
                width: 18,
                height: 18,
                accentColor: 'var(--orange)',
                borderRadius: 'var(--radius)',
                flex: '0 0 auto',
              }}
            />
            <span className="min-w-0">
              <span className="font-medium block">{o.label}</span>
              {o.description && (
                <span className="block text-xs mt-0.5" style={{ color: 'var(--text-dim)' }}>
                  {o.description}
                </span>
              )}
            </span>
          </label>
        );
      })}
    </div>
  );
}

export default CheckboxList;
